<template>
    <c-row>
        <slot />
    </c-row>
</template>
<script setup>
import { CRow } from '@coreui/vue/dist/esm/components/grid/index.js';
</script>
